import React, { useEffect } from "react";
import { getFirestore, collection, onSnapshot, query, where } from "firebase/firestore";

type User = {
  id: string;
  [key: string]: any;
  hashTags: string[];
};

type UsersState = {
  allUsers: User[];
  filteredUsers: User[];
};

type Props = {
  schoolName: string;
  onResolved: (state: UsersState) => void;
};

const UsersInitializer: React.FC<Props> = ({ schoolName, onResolved }) => {
  const db = getFirestore();

  // 学校の画面で内定を登録したときにすぐ反映されるよう、学生のデータは購読する
  useEffect(() => {
    if (!schoolName) return;

    const q = query(
      collection(db, "users"),
      where("education.school", "==", schoolName)
    );

    return onSnapshot(
      q,
      (querySnap) => {
        const users: User[] = querySnap.docs.map((doc) => {
          const data = doc.data();

          return {
            id: doc.id,
            ...data,
            hashTags: [
              data.education?.department,
              data.education?.grade,
              data.education?.class,
            ].filter((v): v is string => Boolean(v)),
          };
        });

        onResolved({
          allUsers: users,
          filteredUsers: users,
        });
      },
      () => {
        onResolved({
          allUsers: [],
          filteredUsers: [],
        });
      },
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [schoolName]);

  return null;
};

export default UsersInitializer;
